import React, { useEffect, useState } from "react";
import * as S from "../../style/StyleComponentSection";
import * as U from "../../style/StyleComponentUtility";
import SelectProductComp from "./SelectProductComp";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";
import { get_estimate_price, insert_estimate } from "../../Axios";
import { useDispatch } from "react-redux";
import { reduxChangePostcode3, reduxChangePostcode4, reduxChangeReservationDivision, reduxChangeReservationHighStatus, reduxChangeReservationSelectedProduct } from "../../redux/ReservationSlice";
import { useNavigate } from "react-router-dom";
import theme from "../../style/theme";

const mainBlack = theme.colors.mainBlack;
const mainWhite = theme.colors.mainWhite;
const lightGray02     = theme.colors.lightGray02;

const Estimate: React.FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const estimateData = useSelector((state:RootState) => state.estimateData);
    const customerData = useSelector((state:RootState) => state.customerData);

    interface IndividualProduct {
        color_name                   : string;
        construction_reservation_pay : number;
        product_kor_name             : string;
        quantity                     : number;
    };

    const [totalPrice, setTotalPrice] = useState<number>(0);
    const [individualPriceList, setIndividualPriceList] = useState <IndividualProduct[]>([]);
    const [propsPriceList, setPropsPriceList] = useState<number[]>([]);
    // const [estimatedDetail, setEstimatedDetail] = useState<>([])

    // 견적 가격 알아보기
    useEffect(() => {
        if(!estimateData.estimate_division) return;
        if(!estimateData.estimate_high_status) return;
        if(!estimateData.selected_product.length) {
            setTotalPrice(0);
            setIndividualPriceList([]);
            return;
        }
        if(!customerData.customer_ablack_rate) return;
        if(estimateData.estimate_division === 3) { if(!estimateData.postcode_1.address || !estimateData.postcode_2.address) return; };
        let arr = [...estimateData.selected_product];
        // 견적 계산할 때 배열에 brand_ID 99 찾아서 빼기
        for(let i = 0; i < arr.length; i++) {
            if(arr[i].brand_ID === 99) {
                arr.splice(i, 1);
            };
        };
        get_estimate_price(
            estimateData.estimate_division,
            estimateData.estimate_high_status,
            arr,
            customerData.customer_ablack_rate,
            estimateData.postcode_1.address,
            estimateData.postcode_2.address
        ).then(result => {
            let list = [];
            let list_price = [];
            let sum = 0;
            for(let i = 0; i < result.length; i++) {
                const item = result[i][0];
                const obj:IndividualProduct = {
                    color_name : item.color_name,
                    construction_reservation_pay : item.construction_reservation_pay,
                    product_kor_name : item.product_kor_name,
                    quantity : item.quantity
                };
                const price = item.construction_reservation_pay;
                list_price.push(price);
                sum += price;
                list.push(obj);
            };
            setPropsPriceList(list_price);
            setIndividualPriceList(list);
            setTotalPrice(sum);
        });
    },[customerData.customer_ablack_rate, estimateData]);


    // 유효성 검사
    const validateEstimate = () => {
        if(!estimateData.estimate_division) return alert('신청할 서비스를 선택하세요.');
        if(!estimateData.selected_product.length) return alert('시공을 원하시는 제품을 선택해주세요.');
        if(!estimateData.estimate_high_status) return alert('시공을 신청하실 천장 높이를 선택해주세요.');
        if(estimateData.estimate_division === 3) {
            if(!estimateData.postcode_1.address || !estimateData.postcode_2.address) return alert('기존 주소와 시공할 주소를 모두 입력해 주세요.');
            if(!estimateData.postcode_1.detail_address || !estimateData.postcode_2.detail_address) return alert('상세주소를 입력해주세요.');
        }
        return true;
    };

    // 에약하러 가기
    const goReservation = () => {
        if(validateEstimate()) {
            dispatch(reduxChangeReservationDivision(estimateData.estimate_division));
            dispatch(reduxChangeReservationSelectedProduct(estimateData.selected_product));
            dispatch(reduxChangeReservationHighStatus(estimateData.estimate_high_status));
            if(estimateData.estimate_division === 3) {
                dispatch(reduxChangePostcode3(estimateData.postcode_1));
                dispatch(reduxChangePostcode4(estimateData.postcode_2));
            }
            navigate('/reservation');
            window.scrollTo(0,0);
        }
    };

    // TODO: 견적 장바구니에 담기 요청
    const insertEstimateCart = () => {
        if(validateEstimate()) {
            if(!window.confirm('장바구니에 추가하시겠습니까?')) return;
            let selectedProductData = [];
            // 계산된 견적 가격 합쳐서 보내주기
            for (let i = 0; i < individualPriceList.length; i++) {
                const obj = {
                    product_ID : estimateData.selected_product[i].product_ID.toString(), 
                    brand_ID   : estimateData.selected_product[i].brand_ID.toString(),
                    quantity   : estimateData.selected_product[i].quantity.toString(),
                    construction_reservation_pay : individualPriceList[i].construction_reservation_pay.toString(),
                    // product_name : `${individualPriceList[i].product_kor_name} - ${individualPriceList[i].color_name} `
                }
                selectedProductData.push(obj);
            };
            insert_estimate(
                customerData.customer_ID,
                estimateData.estimate_division,
                estimateData.estimate_high_status,
                selectedProductData,
                customerData.customer_ablack_rate,
                estimateData.postcode_1,
                estimateData.postcode_2
            ).then(result => {
                if(result === 1) {
                    if(!window.confirm('장바구니로 이동하시겠습니까?')) return;
                    navigate('/shopping_bag');
                }
            });
        }
    };

    return (
        <S.SectionContainer>
            <S.SectionWidth $width={900}>
                <S.SectionTitleBox>
                    <h1>견적 계산기</h1>
                    <h3>
                        A.Black 서비스를 이용하기 전 간편하게 견적을 확인하실 수 있습니다. <br />
                        빠른 견적 계산을 위해 A.Black 서비스에 등록된 브랜드와 제품만 견적 확인 가능합니다
                    </h3>
                </S.SectionTitleBox>

                <SelectProductComp step={3} directPhotoList={[]} setDirectPhotoList={null} propsPriceList={propsPriceList} totalPrice={totalPrice} />

                <U.BreakLine $height={25} />

                <S.SectionContent>
                    <div className="section-flex-box w-[100%] justify-center">
                        <S.EmptyRoundedButton onClick={() => insertEstimateCart()} $width={280} $btnSelect={false} style={{backgroundColor : lightGray02, color : mainBlack}}>
                            견적 장바구니 담기
                        </S.EmptyRoundedButton>
                        <S.EmptyRoundedButton onClick={() => goReservation()} $width={280} $btnSelect={false} style={{backgroundColor : mainBlack, color : mainWhite}}>
                            예약 신청하기
                        </S.EmptyRoundedButton>
                    </div>
                </S.SectionContent>

                <U.BreakLine $height={40} />
                
            </S.SectionWidth>
        </S.SectionContainer>
    )
};

export default Estimate;